import { createSelector, createSlice } from '@reduxjs/toolkit';
import { clearResetPasswordInput, refreshResetPasswordState, } from '../../../views/ResetPassword/resetPasswordSlice.js';
import { clearRegistrationInputs } from '../../../views/Registration/registrationSlice.js';
import { clearLoginInputs } from '../../../views/Login/loginSlice.js';
import { clearAuthError } from '../../core/authError/authErrorSlice.js';
import { clearActiveView, clearActiveWrapper, setActiveView, setActiveWrapper, setIsFullscreen, WRAPPER_TYPES, } from '../../core/wrapperContext/wrapperContextSlice.js';
export const initialStepModalState = {
    isGDPRModalActive: false,
};
export const stepModalSlice = createSlice({
    name: 'stepModal',
    initialState: initialStepModalState,
    reducers: {
        setGDPRModalActive: (state, actions) => {
            state.isGDPRModalActive = actions.payload;
        },
    },
});
export const showStepModalThunk = (formType, isFullscreen) => async (dispatch) => {
    dispatch(setActiveWrapper(WRAPPER_TYPES.STEP_MODAL));
    dispatch(setActiveView(formType));
    dispatch(setIsFullscreen(!!isFullscreen));
};
export const closeStepModalThunk = () => async (dispatch) => {
    dispatch(clearLoginInputs());
    dispatch(clearRegistrationInputs());
    dispatch(clearResetPasswordInput());
    dispatch(refreshResetPasswordState(false));
    dispatch(clearAuthError());
    dispatch(clearActiveWrapper());
    dispatch(clearActiveView());
};
export const stepModalActions = stepModalSlice.actions;
const loginRegistrationStepModalState = (state) => state.wrappers.stepModal;
export const isGDPRModalActiveSelector = createSelector(loginRegistrationStepModalState, (state) => state?.isGDPRModalActive);
export default stepModalSlice.reducer;
//# sourceMappingURL=stepModalSlice.js.map